// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportOverwriteTreeNode.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, computed } from 'mobx';
import { map, concat, forEach, every, isEmpty, filter, getOr, size, some } from 'lodash/fp';

export default class ImportOverwriteTreeNode {
  @observable selfChecked: boolean = false;
  @observable childs: Array<ImportOverwriteTreeNode> = [];

  key: string = '';
  destinationId: string = null;
  name: string = null;
  fileKey: string = null;

  @computed
  get checked() {
    return isEmpty(this.childs) ? this.selfChecked : every('checked', this.childs);
  }

  @computed
  get isLeafNode() {
    return isEmpty(this.childs);
  }

  @computed
  get indeterminate() {
    if (some('indeterminate', this.childs)) {
      return true;
    }
    const count = size(filter('checked', this.childs));
    return !this.isLeafNode && count !== 0 && count !== size(this.childs);
  }

  constructor(node: any, parentNode: any) {
    this.setData(node, parentNode);
  }

  /**
   * Set data
   * @param {any} node
   * @param {any} parentNode
   */
  setData(node: any, parentNode: any): void {
    this.name = node.name;
    this.destinationId = node.destinationId;
    this.fileKey = node.fileKey;
    this.key = `${getOr('Root', 'key', parentNode)}_${this.name}`;
    this.childs = map(
      child => new ImportOverwriteTreeNode(child, this),
      concat(node.objects || [], node.subCategories || [])
    );
  }

  /**
   * Change status of this node and its child nodes
   * @param {boolean} checked
   */
  changeNodeStatus(checked: boolean): void {
    this.selfChecked = checked;
    forEach(node => node.changeNodeStatus(checked), this.childs);
  }

  /**
   * Update selected overwrite option
   * @param {Array<any>} previousOption
   */
  updateOverwriteOption(previousOption: Array<any>): any {
    if (this.isLeafNode) {
      previousOption.push({ fileKey: this.fileKey, destinationId: this.destinationId, isOverwrite: this.checked });
    } else {
      forEach(child => child.updateOverwriteOption(previousOption), this.childs);
    }
    return previousOption;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ImportOverwriteTreeNode.js